module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-latin244.1526cb9.woff2";